import React from "react";
import { Tooltip } from "react-tooltip";

/**
 * "+N" badge for group shifts. Hover (or focus) shows the other participants' names.
 */
const CareWatchExtraParticipantsCount = ({
  count = 0,
  names = [],
  tooltipId,
}) => {
  const extra = Number(count) || 0;
  const labels = (Array.isArray(names) ? names : [])
    .map((name) => String(name || "").trim())
    .filter(Boolean);

  if (extra < 1 || labels.length < 1) {
    return null;
  }

  const id =
    tooltipId ||
    `cw-extra-participants-${labels.join("-").slice(0, 40)}-${extra}`;
  const tooltipText = labels.join(", ");

  return (
    <>
      <span
        className="care-watch-detail-count care-watch-detail-count--interactive"
        data-tooltip-id={id}
        data-tooltip-content={tooltipText}
        tabIndex={0}
        aria-label={`Additional participants: ${tooltipText}`}
      >
        +{extra}
      </span>
      <Tooltip
        id={id}
        place="top"
        variant="dark"
        className="z-[501] !max-w-xs !text-xs !leading-relaxed"
        positionStrategy="fixed"
      />
    </>
  );
};

export default CareWatchExtraParticipantsCount;
